import React from "react";
import "../css-coding/VideoReels.css";

import bgPattern from "../assets/dot-bg.jpg"; // grainy pattern background
import reel1 from "../assets/reel1.mp4";
import reel2 from "../assets/reel2.mp4";
import reel3 from "../assets/reel3.mp4";

const reels = [reel1, reel2, reel3];

const VideoReels = () => {
  return (
    <section
      className="reel-section"
      style={{ backgroundImage: `url(${bgPattern})` }}
    >
      <div className="reel-container">
        {reels.map((video, index) => (
          <div className={`reel-frame rotate-${index % 3}`} key={index}>
            <video
              src={video}
              autoPlay
              loop
              muted
              playsInline
              className="reel-video"
              aria-label={`Video reel ${index + 1}`}
            />
            <div className="volume-icon" title="Muted">🔈</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default VideoReels;
